// src/Hero.js
import React from 'react';
import './hero.css';
import { motion } from 'framer-motion';

const heroContainerVarient = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            delay: 0.5,
            duration: 0.5
        }
    }
}
const leftHeroVarient = {
    hidden : {
        x: '-100vw', 
        opacity: 0
    },
    visible : {
        color: "white",
        x: 0, 
        opacity: 1,
        transition : {
            delay: 0.5,
            duration: 1,
            stiffness: 120
        }
    }
}
const topHeroVarient = {
    hidden: {
        y: '-100vw',
        opacity: 0 
    },
    visible: {
        color: "white",
        y: 0,
        opacity: 1,
        transition : {
            delay: 0.5,
            duration: 1,
            type: 'spring',
            mass: 0.4,
            stiffness: 120 
        }
    }
}
const buttonVariant = {
    hover: {
        opacity: '70%',
        scale: [1, 1.1, 1, 1.1, 1],
        transition: {
            delay: .2,
            duration: .3 
        }
    }
}
export default function Hero() {
    return (
        <motion.div className='hero-container'
            variants={heroContainerVarient}
            initial="hidden"
            animate="visible">
            <div className="hero-text">
                <motion.h2
                    variants={leftHeroVarient}
                >Welcome to Mayheaven</motion.h2>
                <motion.h2
                    variants={topHeroVarient}
                >Building the future of</motion.h2>
                <div className="animate-container">
                    <motion.h2
                        variants={topHeroVarient}
                        className='hero-animate'>decentralized web.</motion.h2>
                </div>
                <motion.button variants={buttonVariant} whileHover="hover" className='hero-button'>Get Started</motion.button>
            </div>
            <div className="hero-video">
                <video src="/assets/video/may.mp4" width={500} controls autoPlay muted></video>
            </div>
            <p className='trusted-by'>Trusted by +3000 companies and start up</p>
            <motion.div className="partners">
                <div className="partner-one">
                    <img src="assets/hero-logo/01-nvidia-logo-horiz-500x200-2c50-d_2x-removebg-preview.png" alt="Nvidia" />
                </div>
                <div className="partner-one">
                    <img src="assets/hero-logo/google2.0.0.1441125613-removebg-preview.png" alt='google' />
                </div>
                <div className="partner-one">
                    <img src="assets/hero-logo/microsoft-removebg-preview.png" alt="Microsoft" />
                </div>
                <div className="partner-one">
                    <img src="assets/hero-logo/whale-removebg-preview.png" alt="Whale" />
                </div>
            </motion.div>
        </motion.div>
    );
}
